import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import RequestManagerUtils from '../../../utils/RequestManagerUtils';
import Utils from '../../../utils/Utils';

class AttachTask extends AbstractRequestTask {
  constructor(groupId = "", css = 0, purchase_id = null) {
    super();
    this.groupId = groupId;
    this.css = css;
    this.purchase_id = purchase_id;
    this.RequestManagerUtils = new RequestManagerUtils();
  }

  getEncType() {
    if (this.getMethod() === 'POST') {
      return 'application/x-www-form-urlencoded';
    }
    else {
      return super.getEncType();
    } 
  }

  /*
  * This service must be call just with logged users
  */
  getUrl() {
    const params = super.getParams();
    //POST request    
    const protocol = "https://";
    const url = Launcher.get("akamai_mfwk");
    if (this.getMethod() === 'POST') {
      const path = params.user_token ? '/services/device/v1/attach?' : '/services/device/attach?';
      let _url = `${protocol}${url}${path}`;
      _url += Utils.buildQueryParams(this.getParams());
      return _url;
    }
    else {
      return `${protocol}${url}/services/device/v1/attach`;
    }
    // return `${protocol}${url}/services/device/attach`;
  }

  getParams() {
    const params = super.getParams();
    if(params.user_token) {
      delete params.HKS;
      delete params.api_version;
    }
    let otherParams = {
      //se remueve param por petición de TL
      //css: this.css,
      group_id: this.groupId
    };
    if(this.purchase_id){
      otherParams = {...otherParams, purchase_id: this.purchase_id};
    }
    
    return { ...params, ...otherParams };
  }

  getShowModal(){
    return false;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return this.RequestManagerUtils.showModalError();
  }

  getMethod() {    
    return 'POST';
  }

  getHeaders() {
    if (!this.method === 'POST') {
      return {
        'Access-Control-Allow-Origin': '*'
      };
    }
    else {
      return {
        'Content-Type': 'application/x-www-form-urlencoded'
      };
    }
  }
}

export default AttachTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/device/AttachTask.js